import { CLEAR_ALL_POST, HIDE_MODAL_POST, SET_ALL_POST, SET_NEW_POST, SHOW_MODAL_POST } from "../constants"

export const hideModalPost = ()=> dispatch =>{
    dispatch({type: HIDE_MODAL_POST})
}

export const showModalPost = ()=> dispatch =>{
    dispatch({type: SHOW_MODAL_POST})
}

export const clearStatePost = ()=> dispatch =>{
    dispatch({type: CLEAR_ALL_POST})
}

export const setNewPost = newPost => dispatch =>{
    dispatch({
        type: SET_NEW_POST,
        payload: newPost,
    })
}

export const setAllPost = allPost => dispatch =>{
    dispatch({
        type: SET_ALL_POST,
        payload: allPost
    })
}